import { render, staticRenderFns } from "./news.vue?vue&type=template&id=d6c84808&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=d6c84808&prod&lang=stylus&scoped=true"
import style1 from "./news.vue?vue&type=style&index=1&id=d6c84808&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c84808",
  null
  
)

export default component.exports